module.exports = __webpack_public_path__ + "files/oracle_certified_professional_java_se_6_programmer.4dd1817b.pdf";